__turbopack_context__.v({
  "button": "SearchInput-module__KxoojG__button",
  "form": "SearchInput-module__KxoojG__form",
  "groupLabel": "SearchInput-module__KxoojG__groupLabel",
  "icon": "SearchInput-module__KxoojG__icon",
  "input": "SearchInput-module__KxoojG__input",
  "inputWrapper": "SearchInput-module__KxoojG__inputWrapper",
  "itemContent": "SearchInput-module__KxoojG__itemContent",
  "label": "SearchInput-module__KxoojG__label",
  "suggestionItem": "SearchInput-module__KxoojG__suggestionItem",
  "suggestions": "SearchInput-module__KxoojG__suggestions",
  "thumbnail": "SearchInput-module__KxoojG__thumbnail",
});
